export default Object.assign(
  JSON.parse(
    JSON.stringify(require("models/block/blocks/command/blueprints/flip.json")),
  ), //make sure all the values are deeply cloned
  {
    args: {
      arguments: [
        {
          code: {
            type: "vector",
            x: 1,
            y: null,
            "hard-lock": true,
            editable: true,
          },
        },
      ],
    },
  },
);
